<template>
    <div class="mb-5 mobile-card">
        <!-- <Skeleton height=".5rem" width="2rem"  class="mb-2"></Skeleton>
        <Skeleton height="0.5rem" width="5rem"  class="mb-4"></Skeleton>
        <Skeleton width="10rem"  height="0.5rem"  class="mb-4"></Skeleton>
        <Skeleton width="10rem" height="1rem"></Skeleton> -->


        <Skeleton height=".5rem" width="20%"  class="mb-2"></Skeleton>
        <Skeleton height="0.5rem" width="35%"  class="mb-3"></Skeleton>
        <Skeleton height="0.5rem"  width="60%" class="mb-3"></Skeleton>
        <Skeleton height="1rem" width="85%"></Skeleton>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({

})
</script>